import * as React from "react";
import i18n from "i18n";

import { observer } from "mobx-react";

import { WBSStore } from "modules/WBS/WBSStore";

import { Typography, withStyles, Tooltip } from "@material-ui/core";

import { Cube } from "common/icons";

const Header3D = observer(({ name }) => {
  const { selectedLine } = WBSStore,
    selected = selectedLine.index === -1;
  const styles = (theme) => ({
    topBar: {
      backgroundColor: "#474747",
      height: "30px",
      width: "100%",
      display: "flex",
      alignItems: "center",
      padding: "0px 10px",
    },
    cube: {
      fontSize: "15px",
      marginRight: "8px",
      color: "#ABC200",
    },
    topBarText: {
      fontFamily: "Raleway",
      fontSize: "10px",
      fontWeight: 700,
      color: "#ABC200",
      textTransform: "uppercase" as any,
    },
    more: {
      color: selected ? "#FFFFFF" : "#bcbcbc",
      fontSize: "22px",
      marginLeft: "auto",
    },
  });
  const Header = ({ classes }) => (
    <div className={classes.topBar}>
      <Cube className={classes.cube} />
      <Typography className={classes.topBarText} component="span">
        {i18n.library.tabTitle3D} - {name}
      </Typography>
    </div>
  );
  const Styled = withStyles(styles)(Header);
  return <Styled />;
});

export default Header3D;



// WEBPACK FOOTER //
// ./src/modules/render3D/components/layouts/Header.tsx